import config from "../config";
import store from "../app/store";
import { validJSON } from "../common/utils";
import { showToast } from "../components/Toast/toast.slice";

const adminPost = async (adminData: any): Promise<any> => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `${localStorage.userAccessToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(adminData),
  };

  return new Promise((resolve, reject) => {
    fetch(`${config[config.env].apiEnspoints.accounts}/admins`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (validJSON(result)) {
          const postResponse = JSON.parse(result);
          if (postResponse.statusCode === 200 && postResponse.success) {
            resolve(postResponse);
          } else {
            throw postResponse.error;
          }
        } else {
          const errorResponse = {
            error: "Error",
            message: "Invalid Response JSON Format",
            code: "Invalid JSON",
          };
          throw errorResponse;
        }
      })
      .catch((error: any) => {
        store.dispatch(showToast(error));
        reject(error);
      });
  });
};

export default adminPost;
